import React from "react";
import CssClasses from "./FullscreenIFrame.css";

import beepMedium from "../../assets/sounds/beep_medium.mp3";

const FullscreenIFrame = props => {
  if (!props.targetURL || props.targetURL === "") {
    return null;
  }

  return (
    <div className={CssClasses.container}>
      <audio
        ref={sound => {
          this.beepMedium = sound;
        }}
      >
        <source src={beepMedium} type="audio/mpeg" />
      </audio>

      <div className={CssClasses.popupBox}>
        <iframe
          title="Stats"
          src={props.targetURL}
          height="100%"
          width="100%"
        />
        <div
          className={CssClasses.btn}
          onClick={() => {
            //daj zvukic
            if (this.beepMedium) {
              //daj zvukic
              this.beepMedium.play();
            }

            props.btnCloseCallback();
          }}
        >
          X
        </div>
      </div>
    </div>
  );
};

export default FullscreenIFrame;



// WEBPACK FOOTER //
// ./src/Components/FullscreenIFrame/FullscreenIFrame.js